import { render, staticRenderFns } from "./account-detail.vue?vue&type=template&id=31b16c12&scoped=true"
import script from "./account-detail.vue?vue&type=script&lang=js"
export * from "./account-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b16c12",
  null
  
)

export default component.exports